export function patientChartCountsQueryKey(patientId: string) {
  return ['patient-chart-counts', { patientId }] as const
}
